<script setup lang="ts">
import { useLocale } from '@composables/useLocale'
import { useLoyaltyPoints } from '@composables/useLoyaltyPoints'
import { User } from '@lib/models/identification'
import { formatNumeric } from '@lib/utils/formatUtils'

const { maxAvailablePoints } = useLoyaltyPoints()

defineProps<{
  user?: User
  locale: string
  decimals: number
}>()

const { t } = useLocale()
</script>
<template>
  <div class="px-vw-16 gap-vh-12 flex flex-col">
    <div class="gap-vw-8 flex flex-row">
      <p class="text-h5">{{ t('¡hola_') }}</p>
      <p class="text-h5 font-bold">{{ user?.name }}!</p>
    </div>
    <div>
      <p class="text-small">{{ t('tienes_disponibles') }}</p>
      <p class="text-h4 bg-loyalty-gradient-ba bg-clip-text font-bold text-transparent">
        {{ t('q_pts_pts', { q_pts: formatNumeric(maxAvailablePoints, locale, decimals) }) }}
      </p>
    </div>
  </div>
</template>
